import { defineMessages } from 'react-intl';

export const buttonMessages: {
	spotlightNextButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightBackButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightTryNowButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightOkButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	spotlightNextButton: {
		id: 'townsquare.twc-onboarding-spotlight.next-button',
		defaultMessage: 'Next',
		description: 'Button indicating the next step in the onboarding spotlight tour',
	},
	spotlightBackButton: {
		id: 'townsquare.twc-onboarding-spotlight.back-button',
		defaultMessage: 'Back',
		description: 'Button indicating the previous step in the spotlight tour',
	},
	spotlightTryNowButton: {
		id: 'townsquare.twc-onboarding-spotlight.try-now-button',
		defaultMessage: 'Try now',
		description:
			'Button indicating the user will be taken to try the feature in the spotlight tour',
	},
	spotlightOkButton: {
		id: 'townsquare.twc-onboarding-spotlight.ok-button',
		defaultMessage: 'Ok',
		description: 'Button indicating user acknowledges spotlight tour',
	},
	closeButtonLabel: {
		id: 'townsquare.twc-onboarding-spotlight.close-button-label',
		defaultMessage: 'Close',
		description: 'Icon label to close the spotlight tour',
	},
});
